import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'Outlive Suicide Prevention';
  routesWithoutSidenav = ['/login', '/forgot-password', '/authenticate', '/reset-password']
  constructor(private router: Router){}

  /* Method to check the current route to show the sidenav in UI */
  showSidenav(){
    let url = this.router.url.split("?")[0]
    return !this.routesWithoutSidenav.includes(url)
  }
}
